import index from "./medeelel.vue";
export default index;
